// extracted by mini-css-extract-plugin
export var footer = "fp-JB";
export var footerNoNav = "fp-3B";
export var footer__accordion__iconCollapsed = "fp-0B";
export var footer__accordion__iconExpanded = "fp-1B";
export var footer__accordion__item = "fp-_B";
export var footer__accordion__itemOpened = "fp--B";
export var footer__accordion__title = "fp-MB";
export var footer__accordion__titleClosed = "fp-KB";
export var footer__accordion__titleOpened = "fp-LB";
export var footer__footnote = "fp-VB";
export var footer__footnoteLeft = "fp-YB";
export var footer__footnoteRight = "fp-ZB";
export var footer__footnote__link = "fp-XB";
export var footer__footnote__text = "fp-WB";
export var footer__layout = "fp-UB";
export var footer__logo = "fp-4B";
export var footer__logoWrapper = "fp-2B";
export var footer__menuGroup = "fp-6B";
export var footer__menuGroupDesktop = "fp-7B";
export var footer__menuGroup__li = "fp-8B";
export var footer__menuGroup__link = "fp-aC";
export var footer__menuGroup__title = "fp-9B";
export var footer__menuGroup__ul = "fp-NB";
export var footer__mobileNav = "fp-5B";
export var grid = "fp-OB";
export var gridWithRowGap = "fp-PB";
export var maxWidthContainer = "fp-TB";
export var mt0 = "fp-CB";
export var mt1 = "fp-DB";
export var mt2 = "fp-EB";
export var mt3 = "fp-FB";
export var mt4 = "fp-GB";
export var mt5 = "fp-HB";
export var mt6 = "fp-IB";
export var removeVisuallyHidden = "fp-RB";
export var visuallyHidden = "fp-QB";
export var widgetBase = "fp-SB";